import React, { useState } from "react";
import { useAuth } from "../auth/AuthContext";
import { sfFetch } from "../api/sfFetch";

export default function AppShell() {
  const { logout, instanceUrl } = useAuth();
  const [output, setOutput] = useState("");

  async function callLimits() {
    try {
      const res = await sfFetch("/services/data/v61.0/limits");
      const json = await res.json();
      setOutput(JSON.stringify(json, null, 2));
    } catch (e) {
      setOutput("Error calling API");
    }
  }

  return (
    <main style={{ padding: 24 }}>
      <h1>App</h1>
      <p>Instance: {instanceUrl ?? "n/a"}</p>
      <div style={{ display: "flex", gap: 8 }}>
        <button onClick={callLimits}>Call Limits API</button>
        <button onClick={() => logout()}>Logout</button>
      </div>
      <pre
        style={{
          marginTop: 16,
          background: "#f6f8fa",
          padding: 12,
          overflow: "auto",
        }}
      >
        {output}
      </pre>
    </main>
  );
}
